import { RouteObject } from "react-router-dom";
import { DevelopmentDropsPage } from "src/routes/developments/drops/DevelopmentDropsPage";
import { LotSummaryPage } from "src/routes/developments/lot-summary/LotSummaryPage";
import { DevelopmentTeamMembers } from "src/routes/developments/team-members/DevelopmentTeamMembers";
import { DocumentsPage } from "src/routes/projects/documents/DocumentsPage";
import { JobLogsPage } from "src/routes/projects/job-logs/JobLogsPage";
import * as overviewPaths from "src/routing/domains/developments/overview/overviewPaths";

/**
 * SideNav leaf routes for development overview section.
 *
 * Role: data router domain leaves. Spread under `DevelopmentSideNavLayout` in `detail/developmentDetail.ts`.
 */
export const overviewSideNavRoutes: RouteObject[] = [
  { path: `${overviewPaths.developmentLotSummaryRoute.path}/*`, Component: LotSummaryPage },
  { path: overviewPaths.developmentDocumentsRoute.path, Component: DocumentsPage },
  { path: overviewPaths.developmentTeamRoute.path, Component: DevelopmentTeamMembers },
  { path: overviewPaths.developmentDropsRoute.path, Component: DevelopmentDropsPage },
  { path: `${overviewPaths.developmentJobLogsRoute.path}/*`, Component: JobLogsPage },
];
